import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import partnerLogAPI from '@infrastructure/partner-log-api';
export const getPartnerLogsAsync = createAsyncThunk('partnerLogs/getAll', async (request, { rejectWithValue }) => {
    try {
        const response = await partnerLogAPI.getPartnerLogs(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
